export default __webpack_public_path__ + "static/media/Franja-superior-Internas.1380a14f.jpg";